import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {KennethMustDie} from "./KennethMustDie";
import {IKMDGameData} from "./server/IKMDData";
import {KMDSound} from "./sound/KMDSound";
import {KMDGameMode} from "./server/KMDGameMode";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class KMDPromoPanelConfig implements PromoPanelGameConfiguration {

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "KenMustDie",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "action_spin_bg/MainGame_Bg"},
            getParsedData: (response: IKMDGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger === ActionSpinSound.WIN) {
            KennethMustDie.soundPlayer.playSound(KMDSound.AS_WIN);
        } else if (trigger === ActionSpinSound.BIG_WIN) {
            KennethMustDie.soundPlayer.playSound(KMDSound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data: IKMDGameData) {
        KennethMustDie.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        KennethMustDie.model.onGame(data);
        KennethMustDie.normalIdle.skip();

        // since all bonus game intro view call this method, using fsIntro instance here, as it doesn't matter
        KennethMustDie.fsIntro.showIntro(() => {
            KennethMustDie.gameFlowController.start();
        });

        // #471, #566
        KennethMustDie.setKeypadWin(true);
        KennethMustDie.keypadPlugin.show(0.01);
    }

    private isBigWin(response: IKMDGameData): boolean {
        const win: number = this.getWin(response),
            playedBetValue: number = response.playedBetValue;
        let winRatio: number = MathHelper.floorToDecimals((win / playedBetValue), 2);

        // #498
        if (response.wasFeatureBuy || KennethMustDie.buyFeatureName === "X_HOLE" || KennethMustDie.buyFeatureName === "X_HOLE_GUARANTEED") {
            const betPrice: number = KennethMustDie.getBuyFeaturePrice();

            winRatio = MathHelper.floorToDecimals((win / betPrice), 2);

            return winRatio >= 1;
        }

        return (winRatio >= KennethMustDie.model.bigWinLevelRatioStarter);
    }

    private getWin(response: IKMDGameData): number {
        return response.totalAvalancheRoundWinnings;
    }

    private getFeatureName(response: IKMDGameData): string {
        if (response.nextMode === KMDGameMode.FREESPIN || response.mode === KMDGameMode.FREESPIN || response.nextMode === KMDGameMode.FREESPIN_AVALANCHE || response.mode === KMDGameMode.FREESPIN_AVALANCHE) {
            return "BEEFY SPINS";
        } else if (response.nextMode === KMDGameMode.FREESPIN_COOL || response.mode === KMDGameMode.FREESPIN_COOL || response.nextMode === KMDGameMode.FREESPIN_COOL_AVALANCHE || response.mode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
            return "BEEFIER SPINS";
        } else if (response.nextMode === KMDGameMode.FREESPIN_SUPER || response.mode === KMDGameMode.FREESPIN_SUPER || response.nextMode === KMDGameMode.FREESPIN_SUPER_AVALANCHE || response.mode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            return "BEEFIEST SPINS";
        }

        return "";
    }

    private isFreeSpinTriggered(response: IKMDGameData): boolean {
        const isNormal: boolean = response.mode.indexOf("NORMAL") > -1;

        return (isNormal && response.nextMode === KMDGameMode.FREESPIN)
            || (isNormal && response.nextMode === KMDGameMode.FREESPIN_COOL)
            || (isNormal && response.nextMode === KMDGameMode.FREESPIN_SUPER);
    }

    private isRoundComplete(response: IKMDGameData): boolean {
        return ([KMDGameMode.NORMAL, KMDGameMode.FREESPIN, KMDGameMode.FREESPIN_COOL, KMDGameMode.FREESPIN_SUPER].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IKMDGameData): boolean {
        // #405
        KennethMustDie.mode = KMDGameMode.NORMAL;

        return (response.mode.indexOf("FREESPIN") > -1) && (response.nextMode === KMDGameMode.NORMAL);
    }
}